angular.module('signalview.collectdPlugins', []);
